<template>
  <div class="page-style">
    <b-row>
      <b-col cols="3">
        <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
      </b-col>

      <b-col cols="6" class="pt-4"> </b-col>

      <b-col cols="3" class="pl-5">
        <b-row><field-label :label="'ID. Relatório'" :field="laudo.numero" /></b-row>
        <b-row><field-date-label :label="'Data'" :field="laudo.data" /></b-row>
      </b-col>
    </b-row>
    <hr />

    <div class="page-body">
      <b-row class="mt-2">
        <b-col cols="12" class="p-0">
          <div class="separador-div">
            <strong>DESCRIÇÃO DO EQUIPAMENTO</strong>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3 ml-3">
        <b-col cols="12" class="p-0 text-left">
          <h5 :style="{ textIndent: 40 + 'px' }">{{ laudo.definicao }}</h5>
        </b-col>
      </b-row>

      <b-row class="mt-3 ml-3">
        <b-col cols="6" class="p-0 text-left">
          <b-table borderless :items="laudo.componentes" :fields="fields.item_componente"> </b-table>
        </b-col>
        <b-col cols="6" class="p-0 text-left">
          <b-img
            :src="laudo.imgThirdPage == null ? require('/static/images/default.png') : laudo.imgThirdPage"
            class="mt-2 max-size"
            center
            fluid
            @click="callImageSelector()"
          />
        </b-col>
      </b-row>
      <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
      <b-row class="mt-2">
        <b-col cols="12" class="p-0">
          <div class="separador-div">
            <strong>NORMAS E DOCUMENTAÇÃO TÉCNICA APLICÁVEL</strong>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="12" class="p-0">
          <b-table bordered hover small :items="laudo.normas" :fields="fields.item_norma"> </b-table>
        </b-col>
      </b-row>
    </div>

    <hr />
    <b-row>
      <h5 class="ml-4">{{ laudo.rodape }}</h5>
    </b-row>
  </div>
</template>

<script>
import FieldAndLabel from "@/components/reports/parts/FieldAndLabel";
import FieldDateAndLabel from "@/components/reports/parts/FieldDateAndLabel";
import ReportFields from "@/tools/ReportFields";

export default {
  name: "ThirdLaudoTecnicoReport",

  props: ["laudo", "equipamento"],

  components: {
    "field-label": FieldAndLabel,
    "field-date-label": FieldDateAndLabel,
  },

  data() {
    return {
      fields: new ReportFields(),
    };
  },

  methods: {
    callImageSelector() {
      this.$emit("callImageSelector");
    },
  },

  setup() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.page-style {
  width: 100%;
}

.page-body {
  height: 1300px;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #003c5a;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.max-size {
  max-height: 560px;
}
</style>
